<template>
  <div>
    <!-- Home Colors -->
    <v-expansion-panels class="mb-4">
      <v-expansion-panel>
        <v-expansion-panel-header>
          <span class="card-title-font">Cores da Página Inicial</span>
          <v-spacer />
          <div class="d-flex align-center justify-end">
            <color-preview :value="colors.home.background" />
            <color-preview :value="colors.home.buttonBackground" />
            <color-preview :value="colors.home.buttonFont" />
            <color-preview :value="colors.home.input" />
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row class="mx-n2">
            <v-col cols="12" md="2" class="pb-4">
              <color-picker
                :value="colors.home.background"
                label="Cor de Fundo"
                :error="getFieldValidationError('colors.home.background')"
                @input="updateColorField('home', 'background', $event)"
              />
            </v-col>
            <v-col cols="12" md="2" class="pb-4">
              <color-picker
                :value="colors.home.buttonBackground"
                label="Cor de Fundo do Botão"
                :error="getFieldValidationError('colors.home.buttonBackground')"
                @input="updateColorField('home', 'buttonBackground', $event)"
              />
            </v-col>
            <v-col cols="12" md="2" class="pb-4">
              <color-picker
                :value="colors.home.buttonFont"
                label="Cor da Fonte do Botão"
                :error="getFieldValidationError('colors.home.buttonFont')"
                @input="updateColorField('home', 'buttonFont', $event)"
              />
            </v-col>
            <v-col cols="12" md="2" class="pb-4">
              <color-picker
                :value="colors.home.input"
                label="Cor do Input"
                :error="getFieldValidationError('colors.home.input')"
                @input="updateColorField('home', 'input', $event)"
              />
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <!-- Form Colors -->
    <v-expansion-panels class="mb-4">
      <v-expansion-panel>
        <v-expansion-panel-header>
          <span class="card-title-font">Cores do Formulário</span>
          <v-spacer />
          <div class="d-flex align-center justify-end">
            <color-preview :value="colors.form.buttonBackground" />
            <color-preview :value="colors.form.buttonFont" />
            <color-preview :value="colors.form.toolbar" />
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row class="mx-n2">
            <v-col cols="12" md="2" class="pb-4">
              <color-picker :value="colors.form.buttonBackground" label="Cor de Fundo do Botão" @input="updateColorField('form', 'buttonBackground', $event)" />
            </v-col>
            <v-col cols="12" md="2" class="pb-4">
              <color-picker :value="colors.form.buttonFont" label="Cor da Fonte do Botão" @input="updateColorField('form', 'buttonFont', $event)" />
            </v-col>
            <v-col cols="12" md="2" class="pb-4">
              <color-picker :value="colors.form.toolbar" label="Cor da Toolbar" @input="updateColorField('form', 'toolbar', $event)" />
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <!-- Finish Colors -->
    <v-expansion-panels class="mb-4">
      <v-expansion-panel>
        <v-expansion-panel-header>
          <span class="card-title-font">Cores da Tela de Finalização</span>
          <v-spacer />
          <div class="d-flex align-center justify-end">
            <color-preview :value="colors.finish.background" />
            <color-preview :value="colors.finish.buttonBackground" />
            <color-preview :value="colors.finish.buttonFont" />
            <color-preview :value="colors.finish.text" />
            <color-preview :value="colors.finish.main" />
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row class="mx-n2">
            <v-col cols="12" md="2" class="pb-4">
              <color-picker :value="colors.finish.background" label="Cor de Fundo" @input="updateColorField('finish', 'background', $event)" />
            </v-col>
            <v-col cols="12" md="2" class="pb-4">
              <color-picker
                :value="colors.finish.buttonBackground"
                label="Cor de Fundo do Botão"
                @input="updateColorField('finish', 'buttonBackground', $event)"
              />
            </v-col>
            <v-col cols="12" md="2" class="pb-4">
              <color-picker :value="colors.finish.buttonFont" label="Cor da Fonte do Botão" @input="updateColorField('finish', 'buttonFont', $event)" />
            </v-col>
            <v-col cols="12" md="2" class="pb-4">
              <color-picker :value="colors.finish.text" label="Cor do Texto" @input="updateColorField('finish', 'text', $event)" />
            </v-col>
            <v-col cols="12" md="2" class="pb-4">
              <color-picker :value="colors.finish.main" label="Cor Principal" @input="updateColorField('finish', 'main', $event)" />
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <!-- Legal Footer Colors -->
    <v-expansion-panels class="mb-4">
      <v-expansion-panel>
        <v-expansion-panel-header>
          <span class="card-title-font">Cores do Rodapé Legal</span>
          <v-spacer />
          <div class="d-flex align-center justify-end">
            <color-preview :value="colors.legalFooter.background" />
            <color-preview :value="colors.legalFooter.font" />
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row class="mx-n2">
            <v-col cols="12" md="2" class="pb-4">
              <color-picker :value="colors.legalFooter.background" label="Cor de Fundo" @input="updateColorField('legalFooter', 'background', $event)" />
            </v-col>
            <v-col cols="12" md="2" class="pb-4">
              <color-picker :value="colors.legalFooter.font" label="Cor da Fonte" @input="updateColorField('legalFooter', 'font', $event)" />
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <!-- Social Networks Footer Colors -->
    <v-expansion-panels class="mb-4">
      <v-expansion-panel>
        <v-expansion-panel-header>
          <span class="card-title-font">Cores do Rodapé das Redes Sociais</span>
          <v-spacer />
          <div class="d-flex align-center justify-end">
            <color-preview :value="colors.socialNetworksFooter.background" />
            <color-preview :value="colors.socialNetworksFooter.font" />
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row class="mx-n2">
            <v-col cols="12" md="2" class="pb-4">
              <color-picker
                :value="colors.socialNetworksFooter.background"
                label="Cor de Fundo"
                @input="updateColorField('socialNetworksFooter', 'background', $event)"
              />
            </v-col>
            <v-col cols="12" md="2" class="pb-4">
              <color-picker :value="colors.socialNetworksFooter.font" label="Cor da Fonte" @input="updateColorField('socialNetworksFooter', 'font', $event)" />
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <v-alert v-if="loading" type="info" class="mt-4"> Carregando configurações... </v-alert>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

export default {
  name: 'HotsiteConfigurationColors',
  components: {
    ColorPicker: () => import('@/modules/configuracoes/site-de-cadastramento/views/components/ColorPicker.vue'),
    ColorPreview: () => import('@/modules/configuracoes/site-de-cadastramento/views/components/ColorPreview.vue'),
  },
  data() {
    return {
      localColors: {},
    }
  },
  computed: {
    ...mapState('hotsiteConfiguration', ['loading']),
    ...mapGetters('hotsiteConfiguration', ['hasData', 'colorsWithDefaults', 'getFieldValidationError']),
    colors: {
      get() {
        return this.colorsWithDefaults
      },
      set(value) {
        this.updateColors(value)
      },
    },
  },
  watch: {
    colorsWithDefaults: {
      immediate: true,
      handler(newColors) {
        this.localColors = { ...newColors }
      },
    },
  },
  methods: {
    ...mapActions('hotsiteConfiguration', ['updateColors', 'clearValidationErrors']),
    updateColorField(section, field, value) {
      // Get current colors and update the specific field
      const currentColors = { ...this.colors }
      if (!currentColors[section]) {
        currentColors[section] = {}
      }
      currentColors[section][field] = value

      this.updateColors(currentColors)

      // Clear validation errors when user updates a field
      this.clearValidationErrors()
    },
  },
}
</script>
